import React, { useState, useEffect } from 'react';
import { useParams, useNavigate, Link } from 'react-router-dom';
import { CircularProgress, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import WhatsAppShare from './WhatsAppShare';
import AdComponent from './AdComponent';
import { READ_COUNT_KEY } from './PushNotificationBanner';
import { structurePost } from './postFormatter';

const PostDetails = () => {
  const { id } = useParams();
  const postId = Number(id);
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [post, setPost] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch(`https://feescrita-138417386089.us-central1.run.app/api/posts/${postId}`)
      .then((response) => response.json())
      .then((data) => {
        if (data.message !== 'Post não encontrado') {
          setPost(structurePost(data));
          // Rastrear leitura para o banner de push notifications
          const count = parseInt(localStorage.getItem(READ_COUNT_KEY) || '0', 10);
          localStorage.setItem(READ_COUNT_KEY, String(count + 1));
        } else {
          setPost(null);
        }
        setLoading(false);
      })
      .catch((error) => {
        console.error('Erro ao carregar o post:', error);
        setLoading(false);
      });
  }, [postId]);

  if (loading) {
    return (
      <main className="fe-post">
        <CircularProgress sx={{ color: '#365E4B' }} />
      </main>
    );
  }

  if (!post) {
    return (
      <main className="fe-post">
        <Typography variant="h6">{t('post_not_found')}</Typography>
      </main>
    );
  }

  return (
    <main className="fe-post">
      <Link to="/" className="fe-back-link">← Todas as reflexões</Link>

      <div className="fe-post-theme">{post.theme}</div>
      <h1 className="fe-post-title">{post.title}</h1>

      {post.verse && (
        <div className="fe-post-verse">
          <div className="fe-post-verse-text">“{post.verse.text}”</div>
          <div className="fe-verse-ref">{post.verse.reference}</div>
        </div>
      )}

      <div className="fe-post-body">{post.reflection}</div>

      <div className="fe-prayer-card">
        <div className="fe-label fe-label-green">Oração curta</div>
        <div className="fe-prayer-text">{post.shortPrayer}</div>
      </div>

      {/* Anúncio após o conteúdo */}
      <div className="fe-post-ad">
        <AdComponent />
      </div>

      <div className="fe-post-actions">
        <WhatsAppShare post={post} />
        <button type="button" className="fe-back-pill" onClick={() => navigate(-1)}>
          {t('back_button')}
        </button>
      </div>
    </main>
  );
};

export default PostDetails;
